import React from 'react';
import PropTypes from "prop-types";

class TaskVideo extends React.PureComponent {
    render() {
        const {task, onTaskUpdate} = this.props;
        return <h1>Task Video</h1>
    }
}

TaskVideo.propTypes = {
    task: PropTypes.object,
    onTaskUpdate: PropTypes.func,
    isCheck: PropTypes.bool,
}
export default TaskVideo;
